var _g, _use;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgContent(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlns: "http://www.w3.org/2000/svg",
    style: {
      width: "100%",
      height: "100%"
    },
    width: 100,
    height: 100,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 100 100",
    id: "svg10756188493",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(12.5 8.333)",
    id: "ss10756188493_1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 25 83.334 C 26.5 83.334 32.045 80.803 37.706 75.741 M 37.706 75.741 C 42.532 71.425 47.443 65.268 50 57.272 C 55.555 39.897 22.222 57.272 33.333 71.751 C 34.7 73.532 36.173 74.834 37.706 75.741 Z M 37.706 75.741 C 44.384 79.691 52.213 76.142 57.517 72.061 C 59.138 70.813 59.949 70.189 60.433 70.383 C 60.917 70.577 61.199 71.693 61.765 73.926 C 63.575 81.071 68.923 86.838 75 77.544",
    fill: "#000000",
    strokeWidth: "3px",
    stroke: "#FFFCF5",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "",
    fillOpacity: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 70.833 45.834 L 70.833 24.544 C 70.833 17.402 70.833 13.83 69.717 10.978 C 67.922 6.392 64.126 2.775 59.313 1.064 C 56.32 0 52.573 0 45.076 0 C 31.958 0 25.398 0 20.16 1.862 C 11.738 4.855 5.095 11.186 1.954 19.211 C 0 24.203 0 30.453 0 42.954 L 0 53.692 C 0 66.64 0 73.114 3.532 77.611 C 4.552 78.907 5.752 80.05 7.096 81.007 C 8.626 82.097 10.373 82.835 12.5 83.334",
    fill: "#000000",
    strokeWidth: "3px",
    stroke: "#FFFCF5",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "",
    fillOpacity: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 0 41.667 C 0 33.997 6.218 27.778 13.889 27.778 C 16.663 27.778 19.934 28.264 22.631 27.541 C 25.027 26.899 26.899 25.027 27.541 22.631 C 28.264 19.934 27.778 16.663 27.778 13.889 C 27.778 6.219 33.996 0 41.667 0",
    fill: "#000000",
    strokeWidth: "3px",
    stroke: "#FFFCF5",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "",
    fillOpacity: 0
  }))))), _use || (_use = /*#__PURE__*/React.createElement("use", {
    href: "#svg10756188493"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContent);
export default __webpack_public_path__ + "static/media/content.bce7f040528f5b8feb16e5901e51f18a.svg";
export { ForwardRef as ReactComponent };